import { ProviderControllerApi, VerifyCosignPinRequest } from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

/** Resolves true when the PIN matches the logged-in Co-Signer's Co-Sign PIN. */
export const useVerifyCosignPin = () =>
  useMutationWithLoading(
    async (params: VerifyCosignPinRequest & { xTENANTID?: string }) =>
      new ProviderControllerApi(getConfigObject())
        .verifyCosignPin({ pin: params.pin }, params.xTENANTID)
        .then((res) => {
          // The SDK types `data` as object; the endpoint actually returns a bare boolean.
          const matches: unknown = res.data?.data;
          return matches === true;
        })
  );
